import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type ExploreHeaderExtensionContextValue = {
  extension: React.ReactNode | null;
  setExtension: (node: React.ReactNode | null) => void;
};

const ExploreHeaderExtensionContext = createContext<ExploreHeaderExtensionContextValue | undefined>(
  undefined,
);

export const ExploreHeaderExtensionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [extension, setExtensionState] = useState<React.ReactNode | null>(null);

  const setExtension = useCallback((node: React.ReactNode | null) => {
    setExtensionState(node);
  }, []);

  const value = useMemo(() => ({ extension, setExtension }), [extension, setExtension]);

  return (
    <ExploreHeaderExtensionContext.Provider value={value}>
      {children}
    </ExploreHeaderExtensionContext.Provider>
  );
};

export function useExploreHeaderExtension(): ExploreHeaderExtensionContextValue {
  const ctx = useContext(ExploreHeaderExtensionContext);
  if (!ctx) {
    throw new Error('useExploreHeaderExtension must be used within ExploreHeaderExtensionProvider');
  }
  return ctx;
}
